import settings from "@settings";
import React from "react";
import { logoContainer, sponsorsContainer } from "./styles";
import { StaticImage } from "gatsby-plugin-image";
import { Divider } from "../Divider";

const Sponsors: React.FC = () => (
  <div css={sponsorsContainer}>
    <div css={settings.mq({ flex: 1 })}>
      <h2 css={{ marginTop: "0 !important" }}>Unsere Sponsoren</h2>
    </div>
    <Divider />
    <div css={logoContainer}>
      <StaticImage
        alt="Ganter Brauerei"
        src={"./images/ganter.png"}
        height={100}
      />
      <StaticImage alt="Sparkasse" src={"./images/sparkasse.jpg"} height={80} />
    </div>
  </div>
);

export default Sponsors;
